import { render, staticRenderFns } from "./goods-columns-active.vue?vue&type=template&id=7a660c8b&scoped=true&"
import script from "./goods-columns-active.vue?vue&type=script&lang=js&"
export * from "./goods-columns-active.vue?vue&type=script&lang=js&"
import style0 from "./goods-columns-active.vue?vue&type=style&index=0&id=7a660c8b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a660c8b",
  null
  
)

export default component.exports